module.exports = __webpack_public_path__ + "9773387a282f9f6ac673e49fa27962b2.svg";